import { MessageModalLayout, Text, WixDesignSystemProvider } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context";
import { PLUGIN_SETTINGS_PANEL_DISCARD_MODAL } from "./../settings-panel-discard-modal/consts";
import classes from "./settings-panel-discard-modal-scss";
const SettingsPanelDiscardModal = ({
  closeModal
}) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(
    WixDesignSystemProvider,
    {
      features: { newColorsBranding: true },
      className: classes.modal_container
    },
    /* @__PURE__ */ React.createElement(
      MessageModalLayout,
      {
        dataHook: PLUGIN_SETTINGS_PANEL_DISCARD_MODAL,
        onCloseButtonClick: () => closeModal({ confirmed: false }),
        primaryButtonOnClick: () => {
          closeModal({ confirmed: true });
        },
        secondaryButtonOnClick: () => closeModal({ confirmed: false }),
        primaryButtonText: t("PluginSettingsPanel_DiscardModal_PrimaryButton_Text"),
        secondaryButtonText: t("PluginSettingsPanel_DiscardModal_SecondaryButton_Text"),
        title: t("PluginSettingsPanel_DiscardModal_Title"),
        content: /* @__PURE__ */ React.createElement(Text, null, t("PluginSettingsPanel_DiscardModal_Content"))
      }
    )
  );
};
export {
  SettingsPanelDiscardModal
};
//# sourceMappingURL=settings-panel-discard-modal.js.map
